import React from "react";
import styled from "styled-components";
import DatePicker from "react-datepicker"; // Import the DatePicker component
import "react-datepicker/dist/react-datepicker.css"; // Import the DatePicker CSS

const CustomDatePicker = styled(DatePicker)`
    width: 100%;
    .react-datepicker {
        display: flex;
    }

    .react-datepicker__header {
        background-color: white !important;
        border-bottom: none;
    }
    @media (max-width: 768px) {
        .react-datepicker__month-container {
            width: 200px; /* 👈 Set your desired width for mobile */
        }
    }
    .react-datepicker__day--highlighted-custom-1 {
        background-color: #006edc; /* Blue highlight for available days */
        color: white;
    }

    .react-datepicker__day--selected {
        background-color: #f39422; /* Orange color for selected date */
        color: white;
    }

    .react-datepicker__time-list-item--selected {
        background-color: #006edc; /* Blue for selected time */
        color: white;
    }

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
        color: #000; /* Black text */
    }

    .react-datepicker__day--disabled {
        color: #ccc; /* Gray out disabled days */
    }
`;
export default function CustomDatePickerComponent({ selectedDate, setSelectedDate }) {
    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    };
    return (
        <CustomDatePicker
            selected={selectedDate}
            minDate={new Date()}
            onChange={(date) => setSelectedDate(date)}
            filterDate={isWeekday}
            showTimeSelect
            dateFormat="MMMM d, yyyy h:mm aa"
            timeFormat="HH:mm"
            timeIntervals={15}
            inline
            className="custom-datepicker"
        />
    );
}
